import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOCanvas } from "src/app/shared/models/oo-canvas";
import { OOCanvasMenuItem } from "src/app/shared/models/oo-canvas-menu-item.model";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";
import { OOMenuItemCanvas } from "src/app/shared/models/oo-menu-item-canvas.model";

@Component({
	selector: "app-menu-item-canvas-view",
	templateUrl: "./menu-item-canvas-view.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class MenuItemCanvasViewComponent implements OnInit {
	@Input() menuItem: OOMenuItem;
	@Input() ooCanvasMenuItems: OOCanvasMenuItem[];
	@Input() ooMenuItemCanvases: OOMenuItemCanvas[];
	@Input() venueKey: number;
	@Input() canvasList: OOCanvas[];

	newRecord: boolean = false;
	ooCanvasMenuItemSelected: OOCanvasMenuItem;

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.ooCanvasMenuItems.forEach((cmi) => (cmi.ooMenuItem = this.menuItem));
	}

	async ooMenuItemCanvasAdd() {
		this.newRecord = true;
		this.ooCanvasMenuItemSelected = new OOCanvasMenuItem({
			venueKey: this.venueKey,
			menuItemKey: this.menuItem.menuItemKey,
			ooMenuItem: this.menuItem,
			online: true,
			taxable: true,
		});
	}

	async onNewEditOOCanvasMenuItemReturn(rec: OOCanvasMenuItem) {
		this.ooCanvasMenuItemSelected = undefined;
		if (this.newRecord) {
			this.ooCanvasMenuItems.push(rec);
			this.newRecord = false;
		} else {
			const idx = this.ooCanvasMenuItems.findIndex((i) => i.canvasKey === rec.canvasKey);
			if (idx > -1) {
				this.ooCanvasMenuItems[idx] = rec;
			}
		}
		this.ngOnInit();
	}

	async ooCanvasMenuItemRemove(rec: OOCanvasMenuItem) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to remove ${this.menuItem.displayName || this.menuItem.name} from the ${
				rec.ooCanvas.displayName || rec.ooCanvas.name
			} canvas?`,
			accept: async () => {
				this.app.loading(true);
				this.focuslink.canvasMenuItemDelete(this.venueKey, rec.canvasKey, rec.menuItemKey);
				this.ooCanvasMenuItems.splice(
					this.ooCanvasMenuItems.findIndex((i) => i.menuItemKey === rec.menuItemKey),
					1
				);
				this.app.loading(false);
				this.app.msgSvc.add({
					severity: "success",
					detail: `${this.menuItem.displayName || this.menuItem.name} removed from ${rec.ooCanvas.displayName || rec.ooCanvas.name} canvas.`,
				});
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
